module.exports = __webpack_public_path__ + "assets/img/progressanalyse.56dcedf4.svg";